import styled, { StyledProps } from 'styled-components/macro';

export type ControlStyles = StyledProps<{}>;

interface ContainerProps {
  direction?: string;
}

type TLabelContainer = {
  color?: string;
  fontSize?: string;
  theme?: any;
  fontWeight?: number;
  margin?: string;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: ${(props: any) =>
    props.direction === 'column' ? 'flex-start' : 'center'};
  justify-content: space-between;
  min-height: 30px;
  flex-direction: ${(props: any) => props.direction || 'row'};
  font-size: 12px;
  color: '#293845';

  position: relative;
  overflow-y: unset;
`;

export const Label = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  color: #293845;
  font-weight: 400;
`;

export const LabelContainer = styled.span<TLabelContainer>`
  display: block;
  ${(
    props = {
      fontWeight: 400,
      fontSize: '12px',
      color: '#293845',
      theme: '',
      margin: '0 0 10px 0',
    }
  ) => `
    font-size: ${props.fontSize};
    color: ${props.color};
    font-weight: ${props.fontWeight};
    margin: ${props.margin};
  `};
  min-height: 12px;
  span {
    color: #cf4845;
    margin-right: 3px;
  }
`;

export const Textarea = styled.textarea`
  border: 1px solid #c3cfd9;
  border-radius: 3px;
  width: 100%;
  resize: none;
  height: 50px;
  line-height: 125%;
  font-size: 14px;

  &:focus {
    outline: none !important;
    border-color: #2684ff;
  }

  &:hover {
    outline: none;
  }

  &.has-error {
    border-color: #cf4845;
  }
`;

export const ControlInfo = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 100%;
  color: #293845;
  margin-top: 5px;
  color: gray;
  &.has-error {
    color: #cf4845;
  }
`;

export const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;
